module.exports = __webpack_public_path__ + "static/girlfeeding_guy-b822d14122f30c036d94d973fde1a0fe.png";